import { useUIStore } from "@/stores/uiStore";

// Throttle quota toasts — at most one per 30 s across all write sites.
let lastQuotaToastAt = 0;

/**
 * localStorage.setItem with QuotaExceededError handling.
 * Shows a throttled error toast so the user knows data wasn't saved.
 * Returns true on success, false on any failure.
 */
export function safeSetItem(key: string, value: string, label?: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (err) {
    const isQuota =
      err instanceof DOMException &&
      (err.name === "QuotaExceededError" || err.code === 22);
    if (isQuota) {
      const now = Date.now();
      if (now - lastQuotaToastAt > 30_000) {
        lastQuotaToastAt = now;
        const subject = label ?? "changes";
        useUIStore
          .getState()
          .addToast(
            `Couldn't save ${subject} — browser storage is full.`,
            "error",
          );
      }
    }
    return false;
  }
}
